import { Heading, Paragraph } from "../../../atoms";
import { Box } from "../../../cores";
import { useViewContext } from "../../../hooks";

interface ICo2Description {
  descriptionTitle: string;
  descriptionText: string;
}

const Co2Description = ({
  descriptionTitle,
  descriptionText,
}: ICo2Description) => {
  const { isMobile } = useViewContext();
  return (
    <Box sx={{ width: "100%" }}>
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
        <sub>2</sub>
      </Heading>
      <Paragraph>{descriptionText}</Paragraph>
    </Box>
  );
};

export default Co2Description;
